import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "sd-cookie-notice-ack-v1";

export const CookieNotice = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        const t = setTimeout(() => setVisible(true), 600);
        return () => clearTimeout(t);
      }
    } catch {
      // localStorage nicht verfügbar – Hinweis dann gar nicht anzeigen
    }
  }, []);

  useEffect(() => {
    const open = () => {
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch {
        /* noop */
      }
      setVisible(true);
    };
    window.addEventListener("sd:open-cookie-notice", open);
    return () => window.removeEventListener("sd:open-cookie-notice", open);
  }, []);

  const acknowledge = () => {
    try {
      localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch {
      /* noop */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Hinweis zur Verwendung technisch notwendiger Speicher"
      className="fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-3xl rounded-xl border border-border bg-card/95 p-4 shadow-2xl backdrop-blur-md sm:p-5"
    >
      <div className="flex items-start gap-3">
        <div className="mt-0.5 rounded-full bg-secondary/15 p-2 text-secondary">
          <Cookie className="h-4 w-4" />
        </div>
        <div className="flex-1 text-sm leading-relaxed text-foreground/90">
          <p>
            Diese Website verwendet ausschließlich <strong>technisch notwendige
            Speicher</strong> (z. B. zur Sitzungsverwaltung im Admin-Bereich und
            zum Speichern dieser Einstellung). Es findet kein Tracking und keine
            Analyse statt. Externe Dienste wie Google Maps werden nur nach Ihrer
            ausdrücklichen Einwilligung geladen. Mehr in unserer{" "}
            <Link to="/datenschutz" className="text-secondary underline">
              Datenschutzerklärung
            </Link>
            .
          </p>
          <div className="mt-3 flex flex-wrap items-center gap-2">
            <button
              type="button"
              onClick={acknowledge}
              className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-primary/90"
            >
              Verstanden
            </button>
            <Link
              to="/datenschutz"
              className="inline-flex items-center justify-center rounded-md border border-border bg-background px-4 py-2 text-sm font-medium text-foreground transition-colors hover:bg-muted"
            >
              Datenschutz
            </Link>
            <Link
              to="/impressum"
              className="inline-flex items-center justify-center rounded-md border border-border bg-background px-4 py-2 text-sm font-medium text-foreground transition-colors hover:bg-muted"
            >
              Impressum
            </Link>
          </div>
        </div>
        <button
          type="button"
          onClick={acknowledge}
          aria-label="Hinweis schließen"
          className="rounded-md p-1.5 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
